import { Component, OnInit, Injector } from '@angular/core';
import { ReportsService, Statuses } from '../reports.service';

@Component({
  selector: 'ga-wo-complete-report-form',
  templateUrl: './ga-wo-complete-report-form.component.html',
  styleUrls: ['../../../dialogs/ga-wo-submit-report-dialog/ga-wo-submit-report-dialog.component.scss',
    '../../../../work-orders.component.scss']
})
export class GaWoCompleteReportFormComponent implements OnInit {
  service: ReportsService;

  constructor(injector: Injector) {
    this.service = injector.get(ReportsService);
    this.service.status = Statuses.Complete;
  }

  ngOnInit() {
    this.service.editForm.get('ActualCompletionDate').setValue(new Date());
    Promise.all([
      this.service.getStatuses(Statuses.Complete),
      this.service.getDefaultContacts(),
      this.service.populateContactsList()
    ]);
  }
}
